import { createSelectorOrm } from "../utils";

export const getExportAddressBooks = createSelectorOrm(session =>
  session.ExportAddressBook.all().toRefArray()
);
